import PropTypes from 'prop-types';
import classNames from 'clsx';

import UnderlineLink from '../../shared/link/UnderlineLink';

import assetUrl from '../../../utils/assetUrl';

import css from './hint.module.scss';

const Hint = ({ className, text, link: { label, to, onClick } }) => (
  <div
    className={classNames(css.hintContainer, className)}
    data-testid="hintContainer"
  >
    <img
      alt="woman listening to alexa"
      className={css.image}
      src={assetUrl('assets/img/woman_listening_alexa.svg')}
      data-testid="hintImg"
    />
    <div className={css.textContainer}>
      <p data-testid="hintText">{text}</p>
      <UnderlineLink
        to={to}
        onClick={onClick}
        className={css.link}
        data-testid="userRegistrationDialogStartLink"
        isDropDown
      >
        {label}
      </UnderlineLink>
    </div>
  </div>
);

Hint.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  link: PropTypes.shape({
    label: PropTypes.string.isRequired,
    to: PropTypes.object,
    onClick: PropTypes.func,
  }),
};

export default Hint;
